import React from 'react';
import { connect } from 'react-redux';
import classes from './SelectedFlight.scss';
import AirlineLogo from '../../../components/Flight/Airline/AirlineLogo/AirlineLogo';

import moment from 'moment';

const selectedFlight = (props) => {
    const flightSchedule = props.type === "onward" ? props.flightScheduleOnward : props.flightScheduleReturn;
    const FS = flightSchedule[0].FS;

    const airlineCode = flightSchedule[0].FS[0].ac;

    return (
        <div className={`p-3 u-borderRadius6 u-backgroundColorLightGrey u-flex f-column`}>
            <div className={`u-flex justify-content-between align-items-center mb-3`}>
                <div className={`u-flex align-items-center`}>
                    <div>
                        <AirlineLogo airlineCode={airlineCode} />
                    </div>
                    <div className={`u-textColorNormal u-fontSize11`}>
                        <span>{props.airlineNames[airlineCode]}</span>
                        <span>{FS[0].oac} {FS[0].fl}</span>
                    </div>
                </div>
                <div className={`u-fontSize11 u-textUppercase u-textColorWhite u-fontWeightMedium u-backgroundColorNormalGrey u-borderRadius3 u-height18 u-textAlignCenter ${classes.ClassType}`}>{FS[0].classtype}</div>
            </div>
            <div className={`u-fontSize15 u-fontWeightMedium u-textColorDark u-flex align-items-center justify-content-between mb-1 u-lineHeight1`}>
                <div>
                    <span>{FS[0].dd}</span>
                    <span>&nbsp;{props.type === "onward" ? props.origin : props.destination}</span>
                </div>
                <div>&mdash;</div>
                <div>
                    <span>{props.type === "onward" ? props.destination : props.origin}</span>
                    <span>&nbsp;{FS[FS.length - 1].ad}</span>
                </div>
            </div>
            <div className={`u-flex justify-content-between u-fontSize11 align-items-center`}>
                <div>{moment(FS[0].ddt).format('DD MMM, ddd')}</div>
                <div>{moment(FS[FS.length - 1].adt).format('DD MMM, ddd')}</div>
            </div>
        </div>
    )    
};

const mapStateToProps = state => {
    return {
        flightScheduleOnward: state.farePrice.flightScheduleOneWay,
        flightScheduleReturn: state.farePrice.flightScheduleRoundTrip,
        origin: state.farePrice.generalData.data.org,
        destination: state.farePrice.generalData.data.dest,
        // date: state.stackFlight.date,
        airlineNames: state.farePrice.generalData.data.airlineNames
    }
}

export default connect(mapStateToProps)(selectedFlight);


// WEBPACK FOOTER //
// ./src/components/Payment/SelectedFlight/SelectedFlight.js